import { useLocation, useNavigate } from "react-router-dom";

export default function BackButton({ fallback }: { fallback?: string }) {
  const nav = useNavigate();
  const loc = useLocation();

  function onBack() {
    // Si no hay history real (por ejemplo entraste por un deep link),
    // navegamos al fallback o al home admin.
    if (window.history.length <= 2) {
      nav(fallback ?? "/admin", { replace: true });
    } else {
      nav(-1);
    }
  }

  // Ocúltalo en rutas raíz
  const hide =
    loc.pathname === "/admin" ||
    loc.pathname === "/app" ||
    loc.pathname === "/login";

  if (hide) return null;

  return (
    <button onClick={onBack} className="btn btn-ghost text-sm">
      ← Volver
    </button>
  );
}
